var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from './framework/AsciiText';
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class Avocor {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.codeOffset = 0x30; // offset for firebase
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: this.makeCommand([0x01, 0x50, 0x4f, 0x57]),
                next: /\x07\x01\x00POW[\s\S]\x08/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x01, 0x47, 0x56, 0x45]), /\x00\x47\x56\x45([\s\S]+)/, tags);
                return match[1] ? match[1] : 'unknown';
            }),
            powerOffRestrictions: ['get'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x01, 0x50, 0x4f, 0x57]), /\x00\x50\x4F\x57([\s\S])\x08/, tags);
                return match[1] === '\x01';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x02, 0x50, 0x4f, 0x57, power ? 1 : 0]), /\x00\x50\x4F\x57([\s\S])/, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 6000);
                this.framework.suspend(power ? 6000 : 2000);
                return match[1] === '\x01';
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x01, 0x4d, 0x49, 0x4e]), /\x00\x4D\x49\x4E([\s\S])/, tags);
                return String.fromCharCode(match[1].charCodeAt(0) + this.codeOffset);
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x02, 0x4d, 0x49, 0x4e, code.charCodeAt(0) - this.codeOffset]), /\x00\x4D\x49\x4E([\s\S])/, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return String.fromCharCode(match[1].charCodeAt(0) + this.codeOffset);
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x01, 0x56, 0x4f, 0x4c]), /\x00\x56\x4f\x4c([\s\S])/, tags);
                return match[1].charCodeAt(0);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x02, 0x56, 0x4f, 0x4c, volume]), /\x00\x56\x4f\x4c([\s\S])/, tags);
                return match[1].charCodeAt(0);
            }),
            range: { max: 100, min: 0, round: 1 },
            powerOffRestrictions: ['get', 'set'],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x01, 0x4d, 0x55, 0x54]), /\x00\x4D\x55\x54([\s\S])/, tags);
                return match[1] === '\x01';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x02, 0x4d, 0x55, 0x54, mute ? 1 : 0]), /\x00\x4D\x55\x54([\s\S])/, tags);
                return match[1] === '\x01';
            }),
        };
        // polling
        this.polls = [
            { intervalMs: 4000, controls: ['power', 'videoInput', 'volume', 'volumeMute'] },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
    // other class methods
    makeCommand(data) {
        data.unshift(0x07, 0x01); // Add STX and IDT to the beginning
        data.push(0x08); // Add ETX to end
        return AsciiText.decode(data);
    }
}
// static properties
Avocor.driverType = 'socketDriver';
Avocor.key = '-MTu3vySEY92FvLP8usb';
Avocor.baseSocketOptions = {
    commandExtractor: {
        terminators: [''],
        unterminatedRegExp: /\x07\x01([\s\S]+)\x08\r/,
    },
    sendTerminator: '\r',
    isBinary: true,
};
Avocor.socketOptions = [
    Object.assign(Object.assign({}, Avocor.baseSocketOptions), { port: 4884 }),
    Object.assign(Object.assign({}, Avocor.baseSocketOptions), { port: 4999 }),
    Object.assign(Object.assign({}, Avocor.baseSocketOptions), { port: 23 }),
];
